<template>
  <svg
    id="svg1"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns:ns1="http://sozi.baierouge.fr"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    inkscape:version="0.46"
    viewBox="0 0 1000 500"
    sodipodi:version="0.32"
    inkscape:output_extension="org.inkscape.output.svg.inkscape"
    sodipodi:docname="united_kingdom.svg"
  >
    <sodipodi:namedview
      id="base"
      inkscape:window-x="353"
      inkscape:window-y="389"
      inkscape:window-height="704"
      inkscape:zoom="0.544"
      showgrid="false"
      inkscape:current-layer="svg1"
      inkscape:cx="500"
      inkscape:cy="250"
      inkscape:window-width="952"
    />
    <g id="g578" transform="scale(16.667)">
      <rect
        id="rect124"
        style="stroke-width: 1pt; fill: #000066"
        height="30"
        width="60"
        y="0"
        x="0"
      />
      <g id="g584">
        <path
          id="path146"
          style="stroke-width: 1pt; fill: #ffffff"
          d="m0 0v3.3541l53.292 26.646h6.708v-3.354l-53.292-26.646h-6.708zm60 0v3.354l-53.292 26.646h-6.708v-3.354l53.292-26.646h6.708z"
        />
        <path
          id="path136"
          style="stroke-width: 1pt; fill: #ffffff"
          d="m25 0v30h10v-30h-10zm-25 10v10h60v-10h-60z"
        />
        <path
          id="path141"
          style="stroke-width: 1pt; fill: #cc0000"
          d="m0 12v6h60v-6h-60zm27-12v30h6v-30h-6z"
        />
        <path
          id="path150"
          style="stroke-width: 1pt; fill: #cc0000"
          d="m0 30l20-10h4.472l-20 10h-4.472zm0-30l20 10h-4.472l-15.528-7.7639v-2.2361zm35.528 10l20-10h4.472l-20 10h-4.472zm24.472 20l-20-10h4.472l15.528 7.764v2.236z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'EnglishIcon'
}
</script>
